import { render, staticRenderFns } from "./guest-reviews.vue?vue&type=template&id=65f542e0&"
import script from "./guest-reviews.vue?vue&type=script&lang=js&"
export * from "./guest-reviews.vue?vue&type=script&lang=js&"
import style0 from "./guest-reviews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports